import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import CloseButton from './CloseButton'
import SwitchLocaleMobileMenu from './Locale/SwitchLocaleMobileMenu'

const MobileMenu = ({ isOpen, handleMenuClose, onOpenCountrySelect, onOpenSigin, isLogged, user, openClaim, openSettings, logOut }) => (
  <div className={classNames('Menu', { 'Menu_show': isOpen })}>
    <div className='Menu__body'>
      <CloseButton className='Menu__close' onClick={handleMenuClose} />
      <div className='Menu__list'>
        {/*<a href='/lots' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          <FormattedMessage id='mobile_menu.auctions' />
        </a>
        <a href='/fixedpricelots' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          <FormattedMessage id='mobile_menu.fixedprices' />
        </a>
        <a href='/help' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          <FormattedMessage id='mobile_menu.help' />
        </a>*/}
        <a href='/about' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          О нас
        </a>
		    <a href='/funds' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          Фонды
        </a>
        <a href='/externalpartners' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          Партнеры
        </a>
        <a href='/actions' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          Акции
        </a>
        {/*<a href='/mechanics' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
          Механики
      </a>*/}
        <a href='/contacts' onClick={handleMenuClose} className='Menu__enter Menu__link Link Head Link_single Link_light'>
          Присоединиться
        </a>
      </div>
      {/*
        isLogged ? <div>
          <a href='/profile' onClick={handleMenuClose} className='Menu__enter Menu__link Link Head Link_single Link_light'>{user.name}</a>
          <a onClick={handleMenuClose}>
            <SwitchLocaleMobileMenu onClick={onOpenCountrySelect} />
          </a>
          <div className='Menu__actions'>
            <button className='Link Link_light Menu__actions-item' onClick={openClaim}>
              <FormattedMessage id='mobile_menu.become_participant' />
            </button>
            <button className='Link Link_light Menu__actions-item' onClick={openSettings}>
              <FormattedMessage id='mobile_menu.settings' />
            </button>
            <button className='Link Link_light Menu__actions-item' onClick={logOut}>
              <FormattedMessage id='mobile_menu.logout' />
            </button>
          </div>
        </div>
          : <div>
            <a className='Menu__enter' onClick={handleMenuClose}>
              <SwitchLocaleMobileMenu onClick={onOpenCountrySelect} />
            </a>
            <button className='Menu__link Link Head Link_single Link_light' onClick={onOpenSigin} type='button'>
              <FormattedMessage id='mobile_menu.login' />
            </button>
          </div>
      */}
    </div>
  </div>
)

export default MobileMenu



// WEBPACK FOOTER //
// ./src/components/MobileMenu.jsx